import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import type { LegendEditorViewModel } from '@/features/legends/LegendEditor/LegendEditorViewModel'
import {
  type PublishCheck,
  PublishPanel,
} from '@/features/legends/versioning/components/PublishPanel'

const testId = 'legend-publish-panel'

export interface PublishPanelContainerProps {
  vm: LegendEditorViewModel
}

export const PublishPanelContainer = observer(function PublishPanelContainer({
  vm,
}: PublishPanelContainerProps) {
  const versionsVm = vm.versionsVm
  const check: PublishCheck = vm.persistAndCheck.match({
    pending: () => 'Pending',
    resolved: (isReady) => (isReady ? 'Ready' : 'Invalid'),
    rejected: () => 'Failed',
  })
  return (
    <PublishPanel
      version={vm.legendVersion?.version ?? 0}
      check={check}
      isPublishPending={versionsVm.publish.pending}
      onClose={versionsVm.publishModal.close}
      onPublish={versionsVm.publish}
      testId={testId}
    >
      <TextAreaContainer
        label="Version notes"
        placeholder="What did you change? Keep it short."
        rows={3}
        model={versionsVm}
        field="versionNotes"
        error={versionsVm.validation.getError('versionNotes')}
        data-test={`${testId}-notes`}
      />
    </PublishPanel>
  )
})
